import { AdminTenantDetails } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useAdminTenantDetails(tenantId: string) {
  const url = `/v2/orm/admin/tenants/${tenantId}?includeConfigs=true`;
  const request = new Request(url);

  return useAuthenticatedRequest<AdminTenantDetails>(request, {
    queryKey: ['admin-tenant-details', tenantId],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
  });
}

export default useAdminTenantDetails;
